<template>
  <div class="template-fields">
    <el-row :gutter="10" type="flex">
      <el-col :span="10">模版名称：<el-input type="text" v-model="form.sceneName" :disabled="+item.sceneType === 1" placeholder="请输入模版名称" clearable></el-input>
      </el-col>
      <el-col :span="4"></el-col>
      <el-col :span="10">
        <el-input type="text" v-model="form.value" placeholder="请输入字段关键字检索" clearable suffix-icon="el-icon-search"
          @clear="clear" @keyup.enter.native="searchCheckBox"></el-input>
        <el-button type="primary" @click="searchCheckBox">检索</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="10" class="organization">
        授权组织：<ybl-select-tree v-model="form.orgAuthorization" :filterDelete="false" :showCheckbox="true"></ybl-select-tree>
      </el-col>
    </el-row>
    <div class="template-fields__header">
      <div class="template-fields__header__item">
        <div class="item__content">已选字段</div>
        <div class="item__tip font12">*可拖动排序</div>
      </div>
      <div class="template-fields__header__item">
        <div class="item__content">未选字段</div>
      </div>
    </div>
    <div class="template-fields__box" v-if="+busiType===200">
      <draggable v-model="rightItems" @change="dragChange" draggable=".template-fields__row,.item" :disabled="+item.sceneType === 1">
        <div class="template-fields__row" v-for="(ite,index) in rightItems" :key="index">
          <div class="template-fields__checkbox__title">
            <el-checkbox :indeterminate="ite.isIndeterminate" v-model="ite.checkAll" :disabled="item.sceneType === 1"
              @change="handleCheckAllChange($event,ite)">{{ite[props.groupName] | groupName}}</el-checkbox>
          </div>
          <div class="template-fields__checkbox__box" :key="`_${index}`">
            <div class="template-fields__checkbox__checkedItems">
              <draggable v-model="ite[props.checked]" @change="dragChange" draggable=".item" :disabled="+item.sceneType === 1">
                <template v-for="(child,cIndex) in ite[props.checked]">
                  <el-checkbox :label="child[props.id]" :key="`_checkbox_${child[props.id]}`" v-model="child.checked" :disabled="+item.sceneType === 1"
                    class="item" @change="checkBoxChange(cIndex,ite)">{{child[props.label]}}</el-checkbox>
                </template>
              </draggable>
            </div>
            <div class="template-fields__checkbox__items">
              <template v-for="(child,cIndex) in ite[props.children]">
                <el-checkbox :label="child[props.id]" :key="`_checkbox_${child[props.id]}`" v-model="child.checked" :disabled="+item.sceneType === 1"
                  @change="rightCheckBoxChange(cIndex,ite)">{{child[props.label]}}</el-checkbox>
              </template>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <div class="template-fields__container" v-else>
      <div class="template-fields__checkbox__left">
        <draggable v-model="leftCheckedItems" @change="dragChange" draggable=".item">
          <template v-for="(child,cIndex) in leftCheckedItems">
            <el-checkbox :label="child[props.id]" :key="`_checkbox_${child[props.id]}`" v-model="child.checked"
              class="item" @change="leftCheckBoxChange(cIndex,child)">{{child[props.label]}}</el-checkbox>
          </template>
        </draggable>
      </div>
      <div class="template-fields__box">
        <div class="template-fields__row" v-for="(item,index) in rightItems" :key="index">
          <div class="template-fields__checkbox__box1" :key="`_${index}`">
            <div class="template-fields__checkbox__title">
              <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll"
                @change="handleCheckAllChange($event,item)">{{item[props.groupName] | groupName}}</el-checkbox>
            </div>
            <div class="template-fields__checkbox__items">
              <template v-for="(child,cIndex) in item[props.children]">
                <el-checkbox :label="child[props.id]" :key="`_checkbox_${child[props.id]}`" v-model="child.checked"
                  @change="rightCheckBoxChange(cIndex,item)">{{child[props.label]}}</el-checkbox>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
export default {
  name: 'template-fields',
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    templates: { // 模版场景集合 （暂时无效 添加了字段（needAuthorization 是否需要字段权限））
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      form: {
        value: '',
        sceneName: '',
        orgAuthorization: []
      },
      originFields: [],
      sceneList: [], // 场景集合
      custom: {
        scene: {},
        searchList: [],
        availableList: []
      },
      system: {
        scene: {},
        searchList: [],
        availableList: []
      },
      props: { label: 'showName', id: 'id', children: 'children', groupName: 'groupName', groupId: 'groupId', 'checked': 'checkedItems' },
      rightItems: [],
      leftCheckedItems: [],
      busiType: ''
    }
  },
  created () {
    const id = this.item.id || this.item.value
    const busiType = +id === 8 ? 200 : 5
    this.busiType = busiType
    const modelType = +id === 8 ? 2 : 1
    if (+id === 8) {
      this.busiFieldsPage(busiType, modelType).then((data) => {
        this.originFields = data.datas || []
        return this.queryExportBusiSceneConfig(id)
      }).then(() => {
        this.initItem()
      })
    } else {
      this.noRequest(busiType, modelType, id)
    }
  },
  computed: {
    ...mapGetters([
      'BUSI_BUSIFIELDSPAGE'
    ]),
    fields () {
      return this.BUSI_BUSIFIELDSPAGE && this.BUSI_BUSIFIELDSPAGE.datas
    },
    dragOptions () {
      return {
        disabled: false
      }
    }
  },
  components: {
    draggable
  },
  methods: {
    async noRequest (busiType, modelType, id) {
      // if (this.fields) {
      //   this.originFields = this.fields
      // } else {
      const data = await this.busiFieldsPage(busiType)
      this.originFields = data.datas || []
      // }
      this.queryExportBusiSceneConfig(id).then(() => {
        this.initItem()
      })
    },
    initItem () {
      let _tempScene = []
      if (this.item.sceneId) {
        _tempScene = this.sceneList.filter(item => +item.id === +this.item.sceneId || +item.relationConfigId === +this.item.sceneId)
        this.form.sceneName = this.item.sceneName
        this.form.orgAuthorization = (_tempScene[0] && _tempScene[0].orgAuthorization && _tempScene[0].orgAuthorization.split(',')) || []
      }
      let _cScene = _tempScene[0]
      _cScene && (this.custom = {
        scene: _cScene,
        availableList: this.getCustomFields(_cScene, 'availableList')// this.originFields.filter(item => this.getSceneFieldIds(_cScene, 'availableList').includes(item.id))
      })
      let _sScene = this.sceneList.find(item => item.sceneType === 1 && item.sceneLabel === '')
      this.system = {
        scene: _sScene,
        availableList: this.originFields.filter(item => this.getSceneFieldIds(_sScene, 'availableList').includes(item.id))
      }
      this.system.availableList = this.getRightFields(this.system.availableList)
      const { configInfoDto: { groupTitleList = [] } = {} } = this.custom.scene || {}

      this.rightItems = [...this.system.availableList]
      if (+this.busiType === 200) {
        if (groupTitleList && groupTitleList.length) {
          this.rightItems = [...this.system.availableList].sort((prev, next) => {
            const prevIndex = groupTitleList.findIndex(item => item.groupName === prev.groupName)
            const nextIndex = groupTitleList.findIndex(item => item.groupName === next.groupName)
            return prevIndex - nextIndex
          })
        }
      } else {
        this.leftCheckedItems = this.custom.availableList.map(item => ({
          ...item,
          checked: true
        }))
      }
    },
    queryExportBusiSceneConfig (id) {
      let params = {
        sceneCategory: id, // 4：上游结算报表导出  6：财务明细报表导出 8 :非车
        needAuthorization: true
      }
      return this.$store.dispatch('busiQueryExportBusiSceneConfig', params).then(data => {
        console.log(data)
        this.sceneList = data.dto || []
        return data
      })
    },
    busiFieldsPage (busiType = 5, modelType = 1) {
      let params = {
        fieldName: '', // 字段名
        fieldType: '', // 字段类型
        groupName: '', // 字段分类
        isTabFilter: '', // 是否支持点选 1：支持，0：不支持
        roleIds: '', // 适用角色
        showName: '', // 显示名称
        busiType: busiType, // 业务类型 1：保单 2：政策 5 新保单字段  200 非车
        status: 1, // 状态 1：启用 2：禁用
        modelType: modelType// 模块类型 1是车险 2是非车
      }
      return this.$store.dispatch('busiBusiFieldsPage', params).then(data => {
        console.log(data)
        return data
      })
    },
    getSceneFieldIds (scene, field) {
      return ((scene && scene.configInfoDto[field]) || []).map(item => item.id)
    },
    getCustomFields (scene, field) { // 排序
      return ((scene && scene.configInfoDto[field]) || []).reduce((sum, item) => {
        let _item = this.originFields.find(o => o.id === item.id)
        _item && sum.push(_item)
        return sum
      }, [])
    },
    getRightFields (data) {
      let temp = new Map()
      return data.reduce((prev, item) => {
        if (!temp.has(item.groupName)) {
          let checked = this.custom.availableList.filter(child => child.groupName === item.groupName).map(item => ({
            ...item,
            checked: true
          }))
          let checkedIds = checked.map(item => item.id)
          let children = data.filter(child => child.groupName === item.groupName && !checkedIds.includes(child.id)).map(item => ({
            ...item,
            checked: false
          }))
          let checkedItems = [...checked]
          temp.set(item.groupName, 1)
          let _item = { ...item }
          _item.children = [...children]
          _item.checkAll = checked.length > 0 // children.length === checkedItems.length
          _item.isIndeterminate = false //! !(checkedItems.length && !item.checkAll)
          _item.checkedItems = checkedItems
          _item.leftChecked = [...checkedIds]
          _item.rightChecked = []
          prev.push({ ..._item })
        }
        return prev
      }, [])
    },
    handleCheckAllChange (val, item) {
      const { busiType, props } = this
      const left = [...item[props.checked]]
      const right = [...item[props.children]]
      item[props.checked] = val ? [...left, ...right].map(item => ({ ...item, checked: true })) : []
      item[props.children] = val ? [] : [...left, ...right].map(item => ({ ...item, checked: false }))
      item.isIndeterminate = false
      if (+busiType !== 200) {
        [...left, ...right].forEach(item => {
          const index = this.leftCheckedItems.findIndex(c => c.id === item.id)
          if (val && index === -1) {
            this.leftCheckedItems.push({ ...item, checked: true })
          } else if (!val && index !== -1) {
            this.leftCheckedItems.splice(index, 1)
          }
        })
      }
    },
    checkBoxChange (index, item) {
      let _item = { ...item[this.props.checked][index] }
      item[this.props.checked].splice(index, 1)
      item[this.props.children].push(_item)
    },
    rightCheckBoxChange (index, item) {
      const { busiType, props } = this
      let _item = { ...item[props.children][index] }
      item[props.children].splice(index, 1)
      item[props.checked].push(_item)
      if (+busiType === 200) {
        this.leftCheckedItems = this.getLeftCheckedItems()
      } else {
        this.leftCheckedItems.push(_item)
      }
    },
    getLeftCheckedItems () {
      const { checked } = this.props
      return this.rightItems.reduce((result, item) => {
        result = [...result, ...item[checked]]
        return result
      }, [])
    },
    leftCheckBoxChange (index, item) {
      this.leftCheckedItems.splice(index, 1)
      const group = this.rightItems.find(group => group.groupName === item.groupName)
      const { children, checked } = this.props
      const _index = group[checked].findIndex(group => group.id === item.id)
      _index !== -1 && group[checked].splice(_index, 1)
      group[children].push(item)
    },
    dragChange () {
      console.log(this.rightItems)
    },
    searchCheckBox () {
      let keyword = this.form.value
      if (!keyword) {
        return
      }
      let boxes = document.querySelectorAll('.template-fields__box')
      let index = 0
      let checkboxLabel = boxes[index].querySelectorAll('.el-checkbox__label')
      let activated = boxes[index].querySelectorAll('.activated')
      let array = [].slice.call(checkboxLabel)
      if (activated.length === 0) {
        this.originHtml = [...array]
      } else {
        this.clear()
      }

      array.forEach(element => {
        let text = element.innerHTML
        if (text.indexOf(keyword) !== -1) {
          let cut = text.split(keyword)
          element.innerHTML = cut.join(`<span class='activated'>${keyword}</span>`)
        }
      })
      this.smoothScroll('.activated')
    },
    smoothScroll (element) {
      let ele = document.querySelector(element)
      ele && ele.scrollIntoView({
        behavior: 'smooth'
      })
    },
    clear () {
      if (this.originHtml) {
        let boxes = document.querySelectorAll('.template-fields__box')
        let index = 0
        let checkboxLabel = boxes[index].querySelectorAll('.el-checkbox__label')
        let array = [].slice.call(checkboxLabel)
        array.forEach((element, index) => {
          let origin = this.originHtml.find(item => item.innerText === element.innerText)
          element.innerHTML = origin.innerText // this.originHtml[index].innerText
        })
      }
    },
    submit () {
      if (!this.form.sceneName) {
        this.$alert('请输入模版名称')
        return
      }
      if (this.rightItems.length === 0) {
        this.$alert('请设置需要导出的字段')
        return
      }
      const { configInfoDto } = this.system.scene
      const { busiType, leftCheckedItems, rightItems } = this
      const item = {
        sceneId: (this.custom.scene && this.custom.scene.id) || 0,
        status: (this.custom.scene && this.custom.scene.status) || 1,
        items: +busiType === 200 ? rightItems : leftCheckedItems,
        sceneName: this.form.sceneName,
        orgAuthorization: this.form.orgAuthorization,
        fieldsOrderDto: (configInfoDto && configInfoDto.fieldsOrderDto) || {},
        groupTitleList: this.rightItems.map(item => ({
          groupName: item.groupName
        }))
      }
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="less">
.template-fields {
  &__box {
    flex:1;
    max-height: 560px;
    overflow: auto;
  }
  &__container {
    display:flex;
  }
  .el-row {
    .el-input {
      width: 65%;
    }
    .organization {
      margin-top: 20px;
      .el-select {
        width: 65%;
        .el-input {
          width: 100%;
        }
      }
    }
  }
  &__checkbox {
    &__title {
      font-weight: bold;
      padding: 10px 0;
      .el-checkbox__label {
        font-weight: bold;
      }
    }
    &__box {
      display: flex;
    }
    &__checkedItems {
      flex: 1;
    }
    &__items {
      flex: 1;
    }
    &__left {
      flex: 1;
      padding-top: 30px;
      .item {
        padding: 2px 0;
        .el-checkbox__label {
          cursor: move;
        }
      }
    }
  }
  &__header {
    border-bottom: 1px solid #eaeaea;
    padding: 10px 0;
    display: flex;
    margin: 30px 0 0 0;
    &__item {
      flex: 1;
      position: relative;
    }
    .item__content {
      border: 1px solid #eaeaea;
      border-bottom: none;
      position: absolute;
      padding: 5px 10px;
      top: -19px;
      background-color: #ffffff;
      z-index: 10;
    }
    .item__tip {
      position: absolute;
      left: 90px;
      top: -12px;
      color: #409eff;
    }
  }
  &__row {
    padding: 10px 5px;
    cursor: move;
    & + & {
      border-top: 1px solid #eaeaea;
    }
    .item {
      padding: 2px 0;
      .el-checkbox__label {
        cursor: move;
      }
    }
    .el-checkbox {
      min-width: 100px;
    }
    .activated {
      background-color: yellow;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/finance/components/templateFields.vue